import { Modal, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSurveyBannerModel } from '../models/SurveyBannerModel';
import { SurveyBannerState } from '../types';
import { Accreditation } from './Accreditation';
import { AddBankAccount } from './AddBankAccount';
import { AnnualIncome } from './AnnualIncome';
import { Banner } from './Banner';
import { ConfigureInvestments } from './ConfigureInvestments';
import { DateOfBirth } from './DateOfBirth';
import { Experience } from './Experience';
import { NetWorth } from './NetWorth';
import { Objectives } from './Objectives';
import { SSN } from './SSN';
import { SetupComplete } from './SetupComplete';
import { StartYourProfile } from './StartYourProfile';
import { VerifyIdentity } from './VerifyIdentity';

export type DobSsnForm = {
  dob: string;
  ssn: string;
};

export const SurveyBanner: React.FC = () => {
  const modalProps = useDisclosure();
  const model = useSurveyBannerModel();
  const dobSsnForm = useForm<DobSsnForm>({
    mode: 'onChange',
  });

  useEffect(() => {
    model.determineAccountSetupState();
  }, []);

  const component: Record<SurveyBannerState, JSX.Element> = {
    ACCREDITATION: <Accreditation modalProps={modalProps} />,
    ADD_BANK_ACCOUNT: <AddBankAccount modalProps={modalProps} />,
    ANNUAL_INCOME: <AnnualIncome modalProps={modalProps} />,
    CONFIGURE_INVESTOR: <ConfigureInvestments modalProps={modalProps} />,
    DOB: <DateOfBirth modalProps={modalProps} form={dobSsnForm} />,
    EXPERIENCE: <Experience modalProps={modalProps} />,
    NET_WORTH: <NetWorth modalProps={modalProps} />,
    OBJECTIVES: <Objectives modalProps={modalProps} />,
    SETUP_COMPLETE: <SetupComplete />,
    SSN: <SSN modalProps={modalProps} form={dobSsnForm} />,
    STARTING_YOUR_PROFILE: <StartYourProfile modalProps={modalProps} />,
    VERIFY_IDENTITY: <VerifyIdentity modalProps={modalProps} />,
  };

  return model.isAuthenticated ? (
    <>
      <Banner setShowModal={modalProps.onOpen} />
      <Modal
        size={['full', 'full', 'xl', '2xl']}
        trapFocus={false}
        closeOnOverlayClick={false}
        scrollBehavior={'outside'}
        isOpen={modalProps.isOpen}
        onClose={modalProps.onClose}>
        <ModalOverlay backdropFilter="brightness(35%) drop-shadow(4px 4px 10px blue)" />
        {component[model.steps[model.currentStep]] ?? component.SETUP_COMPLETE}
      </Modal>
    </>
  ) : null;
};
